var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cod_orders_list" }, [
    _c("table", { staticClass: "table table-striped table-sm table-hover" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.orders, function (o, i) {
          return _c(
            "tr",
            {
              key: o.id,
              on: {
                click: function ($event) {
                  return _vm.selectOrder(o.id)
                },
              },
            },
            [
              _c("td", [
                _c("p", [_vm._v(_vm._s(i + 1))]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedOrders[o.id],
                      expression: "selectedOrders[o.id]",
                    },
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.selectedOrders[o.id])
                      ? _vm._i(_vm.selectedOrders[o.id], null) > -1
                      : _vm.selectedOrders[o.id],
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.selectedOrders[o.id],
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.selectedOrders,
                              o.id,
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.selectedOrders,
                              o.id,
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.selectedOrders, o.id, $$c)
                      }
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("td", [
                _c("p", [_vm._v(_vm._s(_vm.mixinPrintOrderNum(o.id)))]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(o.created_at))]),
              ]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        (o.client && o.client.name) ||
                          o.extra_options.client_name
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  o.phones && o.phones.length
                    ? _vm._l(o.phones, function (phone) {
                        return _c("p", { key: phone.id }, [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.mixinPrintPhone(phone.full_phone))
                            ),
                          ]),
                        ])
                      })
                    : [_c("p", [_vm._v(_vm._s(o.phone))])],
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        (o.client && o.client.email) || o.extra_options.email
                      )
                    ),
                  ]),
                ],
                2
              ),
              _vm._v(" "),
              _c("td", [
                _c("div", { staticClass: "input-group" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: o.address,
                        expression: "o.address",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { disabled: _vm.disableEdit, rows: "2" },
                    domProps: { value: o.address },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(o, "address", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  !_vm.disableEdit
                    ? _c("div", { staticClass: "input-group-append" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-success btn-xs",
                            on: {
                              click: function ($event) {
                                return _vm.updateOrder(o.id)
                              },
                            },
                          },
                          [_c("i", { staticClass: "icon-fa icon-fa-save" })]
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c("td", [
                _c("div", {
                  staticClass: "drugs_list_block",
                  domProps: { innerHTML: _vm._s(_vm.printDrugs(o.details)) },
                }),
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(_vm._s(o.price.toLocaleString("ru-RU")) + "\n      "),
              ]),
              _vm._v(" "),
              _c("td", [
                _c("div", { staticClass: "input-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: o.extra_options.post_sum,
                        expression: "o.extra_options.post_sum",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      disabled: _vm.disableEdit,
                      placeholder: "Почтовые расходы",
                    },
                    domProps: { value: o.extra_options.post_sum },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          o.extra_options,
                          "post_sum",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  !_vm.disableEdit
                    ? _c("div", { staticClass: "input-group-append" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-success btn-xs",
                            on: {
                              click: function ($event) {
                                return _vm.updateOrder(o.id)
                              },
                            },
                          },
                          [_c("i", { staticClass: "icon-fa icon-fa-save" })]
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _vm.appointed
                ? _c("td", [
                    _c("div", { staticClass: "input-group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: o.extra_options.post_track,
                            expression: "o.extra_options.post_track",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          disabled: _vm.disableEdit,
                          placeholder: "Номер с почты",
                        },
                        domProps: { value: o.extra_options.post_track },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              o.extra_options,
                              "post_track",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      !_vm.disableEdit
                        ? _c("div", { staticClass: "input-group-append" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-outline-success btn-xs",
                                on: {
                                  click: function ($event) {
                                    return _vm.updateOrder(o.id)
                                  },
                                },
                              },
                              [_c("i", { staticClass: "icon-fa icon-fa-save" })]
                            ),
                          ])
                        : _c("div", { staticClass: "input-group-append" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-info btn-xs",
                                on: {
                                  click: function ($event) {
                                    return _vm.uploadFileData(o)
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-popover",
                                  {
                                    attrs: {
                                      popoverClass: "1111",
                                      popoverInnerClass:
                                        "upload_file_component_popover",
                                      "auto-hide": true,
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "icon-fa icon-fa-eye",
                                    }),
                                    _vm._v(" "),
                                    _c("template", { slot: "popover" }, [
                                      _c("div", { staticClass: "pre_image" }, [
                                        _vm.uploadedImage[o.id]
                                          ? _c("img", {
                                              attrs: {
                                                src: _vm.uploadedImage[o.id]
                                                  .url,
                                              },
                                            })
                                          : _vm._e(),
                                      ]),
                                    ]),
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                          ]),
                    ]),
                    _vm._v(" "),
                    !_vm.disableEdit
                      ? _c(
                          "div",
                          { staticClass: "text-right" },
                          [
                            _c("UploadFile", {
                              attrs: {
                                orderId: o.id,
                                type: "postTrack",
                                uploadedKey:
                                  o.extra_options.post_track_image || null,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("td", [
                _vm.disableEdit
                  ? _c(
                      "div",
                      [
                        !_vm.popover[o.id] || !_vm.popover[o.id].reject
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-outline-warning btn-xs",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    _vm.popover[o.id].reject = true
                                  },
                                },
                              },
                              [_vm._v("\n            Отменить\n          ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.popover[o.id] && _vm.popover[o.id].reject
                          ? _c(
                              "v-popover",
                              {
                                attrs: {
                                  popoverInnerClass: "reject_popover",
                                  open: _vm.popover[o.id].reject,
                                },
                                on: {
                                  hide: function ($event) {
                                    return _vm.destroyPopover(o.id)
                                  },
                                },
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-outline-warning btn-xs",
                                    attrs: { type: "button" },
                                  },
                                  [
                                    _vm._v(
                                      "\n              Отменить\n            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("template", { slot: "popover" }, [
                                  _c("div", [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("Почтовые расходы"),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            o.extra_options.rejectPostExpenses,
                                          expression:
                                            "o.extra_options.rejectPostExpenses",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: { type: "number" },
                                      domProps: {
                                        value:
                                          o.extra_options.rejectPostExpenses,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            o.extra_options,
                                            "rejectPostExpenses",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "text-right mt-1" },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-warning btn-xs",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.updateOrder(
                                                  o.id,
                                                  "rejectCodDelivery"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Подтвердить")]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                              ],
                              2
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { width: "20" } }),
        _vm._v(" "),
        _c("th", { attrs: { width: "70" } }, [_vm._v("Номер")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "15%" } }, [_vm._v("Клиент")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "25%" } }, [_vm._v("Адрес")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "20%" } }, [_vm._v("Препараты")]),
        _vm._v(" "),
        _c("th", [_vm._v("Сумма")]),
        _vm._v(" "),
        _c("th", [_vm._v("Расходы")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "15%" } }, [_vm._v("Трек номер")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }